import { ApiService } from '../../app-lite/api/api.service';

import TaxGroupsHtml from './settings.tax-groups.html';

export function SettingsStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'TaxGroupsCtrl',
    name       : 'app.tax-groups',
    templateUrl: TaxGroupsHtml,
    url        : '/tax_groups',
    resolve    : {
      groups: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/tax_groups')
    }
  });
};